export enum KYC_COUNTRY {
  NGA = 'NGA',
  US = 'US',
}
